<template>
  <div class="layout">
    <navbar></navbar>
    <siteheader></siteheader>
    <modalcontact></modalcontact>
    <modalafter></modalafter>
    <modalleave></modalleave>
    <div class="section white">
      <div class="container">
        <sitesectionoldsite v-bind:class="{appLightGrey: true}"></sitesectionoldsite>
      </div>
      <sitesectionwide v-bind:class="{appDarkGrey: true}"></sitesectionwide>
      <div class="container">
        <sitesectionme v-bind:class="{appLightGrey: true}"></sitesectionme>
        <sitesection v-bind:class="{appOrange: true}"></sitesection>
      </div>
    </div>
    <sitefooter></sitefooter>
  </div>
</template>

<script>
import Navbar from './Navbar'
import Siteheader from './Siteheader'
import Sitesection from './Sitesection'
import Sitesectionme from './Sitesectionme'
import Sitesectionwide from './Sitesectionwide'
import Sitesectionoldsite from './Sitesectionoldsite'
import Sitefooter from './Footer'
import Modalcontact from './Modalcontact'
import Modalafter from './Modalafter'
import Modalleave from './Modalleave'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Siteheader,
    Sitesection,
    Sitesectionme,
    Sitesectionwide,
    Sitesectionoldsite,
    Sitefooter,
    Modalcontact,
    Modalafter,
    Modalleave
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue